import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { useLocation } from "react-router-dom";
import Table from "../components/Table";
import filePDF from "../assets/images/file-pdf.svg";
import * as am5 from "@amcharts/amcharts5";
import Chart from "../components/Chart";
import Paymentbox from "../components/PaymentInfobox";
import PdfDownloader from "../components/PdfDownloader";
import { Link } from "react-router-dom";
import Skeleton from "@mui/material/Skeleton";
import ErrorComp from "../components/ErrorComp";

const ActiveInsurence = (props) => {
  const [tableHeader, setTableHeader] = useState(
    window.innerWidth < 767
      ? [
          { label: "חברת ביטוח", sortable: false, engTrns: "logo" },
          { label: "סוג הפרמיה", sortable: false, engTrns: "premiumType" },
          { label: "", sortable: false, engTrns: "" },
          { label: "מספר פוליסה", sortable: true, engTrns: "policyNumber" },
          { label: "ענף", sortable: true, engTrns: "mainBranch" },
          { label: "ענף משני", sortable: false, engTrns: "secondaryBranch" },
          { label: "סטטוס", sortable: true, engTrns: "active" },
          { label: "סכום פרמיה", sortable: true, engTrns: "premiumAmount" },
          { label: "תאריך סיום", sortable: true, engTrns: "date" },
        ]
      : [
          { label: "חברת ביטוח", sortable: false, engTrns: "logo" },
          { label: "מספר פוליסה", sortable: true, engTrns: "policyNumber" },
          { label: "ענף", sortable: true, engTrns: "mainBranch" },
          { label: "ענף משני", sortable: false, engTrns: "secondaryBranch" },
          { label: "סטטוס", sortable: true, engTrns: "active" },
          { label: "סכום פרמיה", sortable: true, engTrns: "premiumAmount" },
          { label: "תאריך סיום", sortable: true, engTrns: "date" },
          { label: "סוג הפרמיה", sortable: false, engTrns: "premiumType" },
          { label: "", sortable: false, engTrns: "" },
        ]
  );
  const [horizontalChartsData, setHorizontalChartsData] = useState([]);

  const [data, setData] = useState(null);
  const [dataElem, setDataElem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [dateWiseData, setDateWiseData] = useState();
  const [dateWiseDatabox, setDateWiseDatabox] = useState();

  const calculateTotalAmount = (arrayObject) => {
    return (
      arrayObject?.reduce((total, item) => {
        const coversSum =
          item?.Covers?.reduce(
            (sum, cover) =>
              sum + parseFloat(cover?.PREMIUME_AMOUNT_IN_NIS || 0),
            0
          ) || 0;
        return total + coversSum;
      }, 0) || 0
    );
  };

  const getRandomGreenToBlueColor = (index = 1) => {
    const colors = [
      "#0072E0",
      "#158EA5",
      "#88D892",
      "#5DC8DE",
      "#AD8EE1",
      "#C58EE1",
      "#8EE1D6",
      "#A6E18E",
      "#D8E18E",
      "#DE5DDA",
    ];
    const color = colors[index % colors.length];
    return am5.color(color);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const filteredData1 =
          props?.insurancePolicies?.filter(
            (item) => item?.TAG === "HEALTH" || item?.TAG === "LIFE"
          ) || [];
        const filteredData2 =
          props?.insurancePolicies?.filter(
            (item) => item?.TAG !== "HEALTH" && item?.TAG !== "LIFE"
          ) || [];
        const filteredDataHEALTH =
          props?.insurancePolicies?.filter((item) => item?.TAG === "HEALTH") ||
          [];
        const filteredDataLIFE =
          props?.insurancePolicies?.filter((item) => item?.TAG === "LIFE") ||
          [];
        const filteredDataELEM =
          props?.insurancePolicies?.filter(
            (item) => item?.TAG === "ELEMENTARY"
          ) || [];

        let monthlyYearlyData = {
          monthlyHL: 0,
          yearlyHL: 0,
          monthlyCB: 0,
          yearlyCB: 0,
        };
        filteredData1?.forEach((item) => {
          item?.Covers?.forEach((cover) => {
            const premiumAmount = parseFloat(
              cover?.PREMIUME_AMOUNT_IN_NIS || 0
            );
            if (
              cover?.PREMIUME_TYPE === "2" ||
              cover?.PREMIUME_TYPE === "חודשית"
            ) {
              monthlyYearlyData.monthlyHL += premiumAmount;
            } else if (
              cover?.PREMIUME_TYPE === "1" ||
              cover?.PREMIUME_TYPE === "שנתית"
            ) {
              monthlyYearlyData.yearlyHL += premiumAmount;
            }
          });
        });
        filteredData2?.forEach((item) => {
          item?.Covers?.forEach((cover) => {
            const premiumAmount = parseFloat(
              cover?.PREMIUME_AMOUNT_IN_NIS || 0
            );
            if (
              cover?.PREMIUME_TYPE === "2" ||
              cover?.PREMIUME_TYPE === "חודשית"
            ) {
              monthlyYearlyData.monthlyCB += premiumAmount;
            } else if (
              cover?.PREMIUME_TYPE === "1" ||
              cover?.PREMIUME_TYPE === "שנתית"
            ) {
              monthlyYearlyData.yearlyCB += premiumAmount;
            }
          });
        });

        // Total Data for center of chart -Start
        let monthlyYearlyDataForTotal = {
          monthlyHealth: 0,
          monthlyElem: 0,
          monthlyLife: 0,
          yearlyHealth: 0,
          yearlyElem: 0,
          yearlyLife: 0,
        };

        filteredDataHEALTH?.forEach((item) => {
          item?.Covers?.forEach((cover) => {
            const premiumAmount = parseFloat(
              cover?.PREMIUME_AMOUNT_IN_NIS || 0
            );
            if (
              cover?.PREMIUME_TYPE === "2" ||
              cover?.PREMIUME_TYPE === "חודשית"
            ) {
              monthlyYearlyDataForTotal.monthlyHealth += premiumAmount;
            } else if (
              cover?.PREMIUME_TYPE === "1" ||
              cover?.PREMIUME_TYPE === "שנתית"
            ) {
              monthlyYearlyDataForTotal.yearlyHealth += premiumAmount;
            }
          });
        });
        filteredDataLIFE?.forEach((item) => {
          item?.Covers?.forEach((cover) => {
            const premiumAmount = parseFloat(
              cover?.PREMIUME_AMOUNT_IN_NIS || 0
            );
            if (
              cover?.PREMIUME_TYPE === "2" ||
              cover?.PREMIUME_TYPE === "חודשית"
            ) {
              monthlyYearlyDataForTotal.monthlyLife += premiumAmount;
            } else if (
              cover?.PREMIUME_TYPE === "1" ||
              cover?.PREMIUME_TYPE === "שנתית"
            ) {
              monthlyYearlyDataForTotal.yearlyLife += premiumAmount;
            }
          });
        });
        filteredDataELEM?.forEach((item) => {
          item?.Covers?.forEach((cover) => {
            const premiumAmount = parseFloat(
              cover?.PREMIUME_AMOUNT_IN_NIS || 0
            );
            if (
              cover?.PREMIUME_TYPE === "2" ||
              cover?.PREMIUME_TYPE === "חודשית"
            ) {
              monthlyYearlyDataForTotal.monthlyElem += premiumAmount;
            } else if (
              cover?.PREMIUME_TYPE === "1" ||
              cover?.PREMIUME_TYPE === "שנתית"
            ) {
              monthlyYearlyDataForTotal.yearlyElem += premiumAmount;
            }
          });
        });
        // Total Data for center of chart - End

        setDateWiseData(monthlyYearlyData);
        const paymentData = [
          {
            amounts: {
              monthly:
                monthlyYearlyDataForTotal?.monthlyHealth +
                monthlyYearlyDataForTotal?.yearlyHealth / 12,
              // yearly: monthlyYearlyDataForTotal?.yearlyHealth + monthlyYearlyDataForTotal?.monthlyHealth * 12,
            },
          },
          {
            amounts: {
              monthly:
                monthlyYearlyDataForTotal?.monthlyLife +
                monthlyYearlyDataForTotal?.yearlyLife / 12,
              // yearly: monthlyYearlyDataForTotal?.yearlyLife + monthlyYearlyDataForTotal?.monthlyLife * 12,
            },
          },
          {
            amounts: {
              monthly:
                monthlyYearlyDataForTotal?.monthlyElem +
                monthlyYearlyDataForTotal?.yearlyElem / 12,
              // yearly: monthlyYearlyDataForTotal?.yearlyElem + monthlyYearlyDataForTotal?.monthlyElem * 12,
            },
          },
        ];
        setDateWiseDatabox(paymentData);
        setData(filteredData1);
        setDataElem(filteredData2);
        const calculateMonthlyValue = (covers = []) => {
          return covers.reduce((sum, cover) => {
            const amount = parseFloat(cover?.PREMIUME_AMOUNT_IN_NIS || 0);
            if (
              cover?.PREMIUME_TYPE === "2" ||
              cover?.PREMIUME_TYPE === "חודשית"
            ) {
              return sum + amount;
            }

            if (
              cover?.PREMIUME_TYPE === "1" ||
              cover?.PREMIUME_TYPE === "שנתית"
            ) {
              return sum + amount / 12;
            }

            return sum;
          }, 0);
        };
        const transformedData =
          filteredDataHEALTH?.map((element, index) => ({
            category: element?.MAIN_BRANCH || "-",
            value: calculateMonthlyValue(element?.Covers),
            settings: {
              fill: getRandomGreenToBlueColor(index),
            },
          })) || [];
        const transformedDataLIFE =
          filteredDataLIFE?.map((element, index) => ({
            category: element?.MAIN_BRANCH || "-",
            value: calculateMonthlyValue(element?.Covers),
            settings: {
              fill: getRandomGreenToBlueColor(index),
            },
          })) || [];
        const transformedDataELEM =
          filteredDataELEM?.map((element, index) => ({
            category: element?.MAIN_BRANCH || "-",
            value: calculateMonthlyValue(element?.Covers),
            settings: {
              fill: getRandomGreenToBlueColor(index),
            },
          })) || [];
        let arrayDataForChart = [
          {
            id: `chart1-${props?.insurancePolicies?.length || 0}`,
            title: "אלמנטרי",
            total: paymentData ? paymentData[2]?.amounts?.monthly : 0,
            totalLabel: "סך הכל מזומן",
            data: aggregateData(transformedDataELEM),
          },
          {
            id: `chart2-${props?.insurancePolicies?.length || 0}`,
            title: "בריאות",
            total: paymentData ? paymentData[0]?.amounts?.monthly : 0,
            totalLabel: "סך הכל מזומן",
            data: aggregateData(transformedData),
          },
          {
            id: `chart3-${props?.insurancePolicies?.length || 0}`,
            title: "חיים",
            total: paymentData ? paymentData[1]?.amounts?.monthly : 0,
            totalLabel: "סך הכל מזומן",
            data: aggregateData(transformedDataLIFE),
          },
        ];
        setHorizontalChartsData(arrayDataForChart);
      } catch (err) {
        console.error(err);
      } finally {
        if (props?.onboardingStep >= 3) {
          setLoading(false);
        }
      }
    };
    fetchData();
  }, [props?.insurancePolicies, props?.onboardingStep]);

  useEffect(() => {
    setLoading(false);
  }, [props?.onboardingStep]);

  const aggregateData = (transformedData) => {
    return (
      transformedData?.reduce((acc, item) => {
        const existingCategory = acc?.find(
          (obj) => obj?.category === item?.category
        );

        if (existingCategory) {
          existingCategory.value += item?.value || 0;
        } else {
          acc?.push({
            category: item?.category || "-",
            value: item?.value || 0,
            settings: { fill: item?.settings?.fill },
          });
        }

        return acc;
      }, []) || []
    );
  };

  const [UserData, setUserData] = useState({});
  const getUser = async () => {
    setUserData(props?.data || {});
  };

  useEffect(() => {
    if (
      window.location.pathname !== "/login" &&
      window.location.pathname !== "/register"
    ) {
      getUser();
    }
  }, [props?.data]);

  return (
    <>
      <div className="heading-wrap d-flex justify-content-between">
        <div className="heading">
          <div className="head-wrap">
            <Breadcrumbs className="breadcrumbs" aria-label="breadcrumb">
              <Link to="/profile" underline="hover">
                {UserData.full_name}
              </Link>
              <Typography>
                <b>ביטוח</b>
              </Typography>
            </Breadcrumbs>
            <h1>ברוכים השבים , {UserData.full_name}</h1>
          </div>
          <div className="btn btn-img pdf_btn">
            <PdfDownloader fileName="active-insurance.pdf">
              <img src={filePDF} alt="" />
            </PdfDownloader>
          </div>
          <p>
            ברוכים הבאים ללוח הבקרה של אובקטיבי <br />
            זהו המרכז שלכם לניהול ושיפור המצב הפיננסי, הפנסיוני והביטוחי שלכם.
            כאן תוכלו למצוא סקירה מקיפה של כל המוצרים והפוליסות שלכם, ביטוחים,
            פנסיה, חסכונות, קרנות, הלוואות, נתוני פרישה, אפשרויות משיכה ועוד..
            הכל כאן ! <br />
            כל אחד מלוחות הבקרה נועד לספק לכם תובנות ברורות והמלצות לפעולה.
            הציצו לעמודים הפנימיים כדי להעמיק בנתונים שלכם, לעקוב אחר ההתקדמות
            ולגלות הזדמנויות לשיפור עתידכם הפיננסי - הכול בפלטפורמה אוביקטיבית
            אחת.
          </p>
        </div>
        <div className="btns-row">
          <div className="btn btn-img pdf_btn">
            <PdfDownloader fileName="active-insurance.pdf">
              <img src={filePDF} alt="" /> הפקת דוח
            </PdfDownloader>
          </div>
        </div>
      </div>
      {props.onboarding_error == 1 && <ErrorComp />}

      <div className="insurances-section">
        <div className="title">
          <h2>ביטוחים</h2>
        </div>
        <div className="row chart-row">
          {horizontalChartsData.length === 0 || loading
            ? [...Array(3)].map((_, index) => (
                <div className="col-4" key={`skeleton-${index}`}>
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={300}
                    animation="wave"
                    sx={{
                      backgroundColor: "rgba(0, 0, 0, 0.05)",
                      borderRadius: 1,
                    }}
                  />
                </div>
              ))
            : horizontalChartsData.map((chart, index) => (
                <div className="col-4" key={`insurances-${index}`}>
                  {console.log("chart.total", chart.total)}
                  <Chart
                    id={`hor${index}`}
                    data={chart.data}
                    total={chart.total}
                    title={chart.title}
                    totalLabel={chart.totalLabel}
                    variant="insurances"
                    spaces="noSpaces"
                  />
                </div>
              ))}
        </div>
      </div>

      <Table
        tableHeader={tableHeader}
        data={data}
        from="insurencePolicies"
        title="ביטוחי חיים ובריאות"
        loading={loading}
        notFoundMessage="ביטוח"
        carrierLogos={props?.carrierLogos}
      />
      <Table
        tableHeader={tableHeader}
        data={dataElem}
        from="insurencePolicies"
        title="ביטוחי רכב דירה עסק"
        loading={loading}
        notFoundMessage="ביטוח"
        carrierLogos={props?.carrierLogos}
      />

      <Paymentbox dateWiseData={dateWiseData} loading={loading} />
    </>
  );
};

export default ActiveInsurence;
